import $ from 'jquery';

$('.top-bar-menu__navigation').on('click', (e) => {
	$('body').addClass('off-canvas-open');
});

$('.top-bar-menu__navigation--close').on('click', (e) => {
	$('body').removeClass('off-canvas-open');
});

$('.off-canvas__content_menu .menu-item-has-children > a .submenu-toggle').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $menuItem = $(this).closest('.menu-item-has-children');
    const $submenu = $menuItem.find('ul.submenu');
    $submenu.toggleClass('submenu--open');
	const $svg = $menuItem.find('svg');
	$svg.toggleClass('submenu-toggle--open');
});
